export const getValidateStatus = (touched, error, warning, valid) => {
  if (touched) {
    if (error) return 'error';
    if (warning) return 'warning';
    if (valid) return 'success';
  }
  return '';
};

const mapError = ({
  meta: { touched, error, warning, valid } = {},
  input: { ...inputProps } = {},
  ...props
}) => {
  const result = {
    ...props,
    ...inputProps,
    validateStatus: getValidateStatus(touched, error, warning, valid),
    help: touched && (error || warning),
  };

  // Preserve custom onBlur alongside input.onBlur (same pattern as onChange in customMap).
  // Without this, input.onBlur overwrites custom onBlur passed to <Field>.
  const customOnBlur = props.onBlur;
  if (customOnBlur && inputProps.onBlur) {
    const primaryOnBlur = result.onBlur;
    result.onBlur = (...args) => {
      primaryOnBlur(...args);
      customOnBlur(...args);
    };
  }

  return result;
};

const mapErrorFields = (fields) => {
  const { names, ...props } = fields;
  const value = [];

  const validationStatus = names.reduce((status, name) => {
    const { meta: { touched, error, warning, valid } = {} } = fields[name];
    return status || getValidateStatus(touched, error, warning, valid);
  }, '');

  let helpInner;
  const help =
    names.reduce((status, name) => {
      const { meta: { touched, error, warning } = {} } = fields[name];
      helpInner = touched && (error || warning);
      return helpInner;
    }, undefined) || helpInner;

  return {
    value,
    help,
    validationStatus,
    ...props,
  };
};

export const customMap = (customPropsFun) => (props) => {
  const mapped = mapError(props);
  const custom = customPropsFun(props);
  const result = { ...mapped, ...custom };

  // When a <Field onChange={customFn}> is used inside react-final-form,
  // mapError spreads input props (including input.onChange) over custom props,
  // losing the custom onChange. Preserve it by calling both: primary first
  // (updates field value), then custom (side effects like resetting dependent fields).
  const customOnChange = props.onChange;
  if (customOnChange && props.input?.onChange) {
    const primaryOnChange = result.onChange;
    result.onChange = (...args) => {
      primaryOnChange(...args);
      customOnChange(...args);
    };
  }

  return result;
};

export const customMapFields = (customPropsFun) => (fields) => ({
  ...mapErrorFields(fields),
  ...customPropsFun(fields),
});

export default mapError;
